<template>
  <search-bar :searchKey="keyword" />
  <div class="tabs">
    <a class="tab-item on">综合</a>
    <a class="tab-item">视频</a>
    <a class="tab-item">网盘</a>
    <a class="tab-item">种子</a>
  </div>
  <div class="result-panel">
    <div class="search-together">
      <div class="order-tabs">
        <a class="order-tab-item on">默认排序</a>
        <a class="order-tab-item">播放多</a>
        <a class="order-tab-item">新发布</a>
        <a class="order-tab-item">弹幕多</a>
      </div>
    </div>
  </div>
  <div class="list-view">
    <van-list
        v-model:loading="loading"
        :finished="finished"
        :finished-text="finishedText"
        @load="onLoad"
    >
      <div class="video-list">
        <div class="card-box">
          <router-link :to="{ name: 'VideoPlay', query: { pid: video.ID } }" v-for="video in videos" :key="video.id">
            <div class="v-card-single" scrollshow="true"><!---->
              <div class="card">
                <div class="pic-box">
                  <div class="img-wrap">
                    <div class="b-img">
                      <picture class="img_inner">
                        <img class="img"
                             :src="video.Cover"
                             :alt="video.Title"
                             loading="lazy"
                        >
                      </picture>
                    </div>
                  </div>
                  <span class="duration">{{statsDuration(video.Duration)}}</span>
                </div>
                <div class="info">
                  <h2 class="title">{{ video.Title }}</h2>
                  <p class="author">
                    <i class="iconfont ic_up"></i>{{ video.Upper?.Name }}
                  </p>
                  <p class="count">
                <span>
                  <i class="iconfont icon_shipin_bofangshu"></i>
                  {{video.views?video.views:"--"}}
                </span>
                    <span>
                  <i class="iconfont icon_shipin_danmushu"></i>
                  {{ video.comments?video.comments : "--" }}
                </span>
                  </p>
                </div>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
import searchBar from "@/views/search/searchBar";

export default {
  name: "searchResult",
  data(){
    return {
      loading: false,
      finished: false,
      finishedText : '没有更多了',
      videos:[],
      offset:0,
      limit:20,
    }
  },
  components:{
    searchBar
  },
  computed: {
    keyword() {
      return this.$route.params.keyWord || '';
    }
  },
  methods:{
    onLoad(){
      setTimeout(() => {
        this.searchVideos().finally(()=>{
          this.loading = false;
        });
        this.offset += this.limit;
      }, 1000);
    },
    async searchVideos() {
      this.loading = true; // 开始加载
      try {
        const res = await this.$v_http.post(`/search?keyword=${this.keyword}&offset=${this.offset}`);
        if (res.data?.code === 0) {
          const videoList = res.data.data?.Videos
          console.log(videoList)
          this.videos = this.offset === 0 ? videoList : [...this.videos, ...videoList];
          if (videoList.length < 10) this.finished = true;
        } else if(res.data?.code==-500){
          console.error("获取视频列表失败：");
          this.finishedText ="服务器错误！联系管理员"
          this.finished = true;
          return
        } else if (res.data?.code==-404){
          console.error("获取视频列表失败：");
          this.finished = true;
          return
        }
      } catch (error) {
        console.error('Error fetching upper info:', error);
        this.finished = true;
      }
    },
    search(){
      this.offset = 0;
      this.loading = false;
      this.finished = false,
      this.videos = [];
      this.searchVideos()
    },
    statsDuration(seconds){
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = seconds % 60;
      return hours>0?`${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`:`${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
    },
  },
  watch:{
    '$route.params.keyWord': function(newKeyword, oldKeyword) {
      if (newKeyword !== oldKeyword) {
        this.search();
      }
    }
  }
}
</script>

<style scoped lang="scss">
  h2{
    margin: 0;
    bottom: 0;
  }
  .tabs{
    height: 11.73333vmin;
    padding: 0 5.33333vmin;
    display: flex;
    justify-content: space-between;
    position: fixed;
    top: 11.73333vmin;
    left: 0;
    right: 0;
    z-index: 2;
    background: #fff;
    .tab-item{
      display: inline-block;
      height: 8vmin;
      line-height: 8vmin;
      color: #757575;
      font-size: 3.73333vmin;
      margin-top: 1.86667vmin;
    }
    .on{
      color: #fb7299;
      border-bottom: 0.53333vmin solid #fb7299;
    }
  }
  .result-panel{
    padding-top: 23.46667vmin;
    background: #f4f4f4;
    .order-tabs {
      height: 10.66667vmin;
      padding: 0 5.33333vmin;
      line-height: 10.66667vmin;
      display: flex;
      justify-content: space-between;
      background: #f9f9f9;
      border-top: 0.53333vmin solid #f4f4f4;
      .order-tab-item{
        display: inline-block;
        color: #757575;
        font-size: 3.73333vmin;
      }
      .on {
        color: #fb7299;
      }

    }
  }
  .list-view{
    position: relative;
    min-height: 53.33333vmin;
    margin-bottom: 5.33333vmin;
    height: 80vh;
    overflow-y: auto;
    .v-card-single{
      display: flex;
      padding: 1.6vmin;
      .card{
        display: flex;
        flex: 1;
        .pic-box{
          position: relative;
          width: 37.33333vw;
          background-color: #f3f3f3;
          border-radius: 1.06667vmin;
          overflow: hidden;
          .img-wrap {
            position: relative;
            width: 100%;
            height: 0;
            padding-bottom: 56.25%; /* 16:9 aspect ratio */
            .b-img{
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              overflow: hidden;
              background: transparent;
              .img_inner {
                display: block;
                width: 100%;
                height: 100%;
                .img {
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                }
              }
            }
          }
          .duration{
            position: absolute;
            right: 1.06667vmin;
            bottom: 1.06667vmin;
            font-size: 3.2vmin;
            padding: 0 0.53333vmin;
            color: #fff;
            border-radius: 0.53333vmin;
            background: rgba(0, 0, 0, .5);
          }
        }
        .info {
          flex: 1;
          font-size: 3.2vmin;
          color: #999;
          margin-left: 2.66667vmin;
          .iconfont{
            margin-right: 1.33333vmin;
            font-size: 4.26667vmin;
          }

          .title{
            font-size: 3.73333vmin;
            font-weight: 400;
            color: #222;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            margin-bottom: 1.06667vmin;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          .author{
            display: flex;
            align-items: center;
            margin-bottom: 1.06667vmin;
            margin-right: 1.33333vmin;
          }
          .count{
            display: flex;
            align-items:center;
            :first-child{
              margin-right: 2.66667vmin;
            }
            span{
              display: flex;
              align-items: center;

            }
          }
        }
      }

    }

  }
</style>
